module.exports = __webpack_public_path__ + "img/bg-bvic2.58f1b1ab.png";